import { useSuspenseQuery } from "@tanstack/react-query"
import { Suspense } from "react"
import { EmptyChildrenState } from "@/features/children/EmptyChildrenState"
import { useSelectedChild } from "@/features/children/useSelectedChild"
import { PageLoader } from "@/shared/components/PageLoader"
import { historyFrom, sessionsQueryOptions } from "./api/history.queries"
import { dayHeader, dayKey, groupByDay } from "./history.config"
import { SessionRow } from "./SessionRow"

export function HistoryPage() {
  const { selectedChild } = useSelectedChild()

  if (!selectedChild) {
    return <EmptyChildrenState />
  }

  return (
    <Suspense fallback={<PageLoader />}>
      <HistoryView key={selectedChild.id} childId={selectedChild.id} />
    </Suspense>
  )
}

function HistoryView({ childId }: { childId: string }) {
  const { data: sessions } = useSuspenseQuery(sessionsQueryOptions(childId, historyFrom()))
  const groups = groupByDay(sessions)
  const todayKey = dayKey(new Date())

  return (
    <main className="flex flex-col gap-4 p-4">
      <h1 className="text-lg font-semibold">Historik</h1>
      {groups.length === 0 ? (
        <p className="text-sm text-muted-foreground">Ingen sömn registrerad ännu</p>
      ) : (
        groups.map((group) => (
          <section key={group.key} className="flex flex-col gap-1">
            <h2 className="px-2 text-xs font-medium uppercase tracking-wide text-muted-foreground">
              {dayHeader(group.key, todayKey)}
            </h2>
            {group.sessions.map((session) => (
              <SessionRow key={session.id} session={session} />
            ))}
          </section>
        ))
      )}
    </main>
  )
}
